import { Colors } from '../consts/Colors';
import ItemZoneDone from './ItemZoneDone';

export default class ItemZone extends Phaser.GameObjects.Container {
    constructor(scene, x, y, itemData) {
        super(scene, x, y, []);
        scene.add.existing(this);
        this.scene = scene;
        this.isDone = false;
        this.index = itemData.trueId;
        this.doneImg = itemData.image;
        this.zoneId = itemData.zoneId;
        this.trueId = itemData.trueId;
        this.otherId = itemData.otherId;
        this.itemData = itemData;
        this.isError = false;
        this.item = this.scene.add.image(0, 0, 'imgPlaceholder').setOrigin(0.5);

        this.dropZone = this.scene.add.rectangle(0, 0, this.item.width + 50, this.item.height + 50, Colors.Elmt.Blue, 0).setOrigin(0.5);
        this.dropZone.setStrokeStyle(1, Colors.Elmt.Black, 0);
        this.add(this.item);
        this.add(this.dropZone);

    }

    setActive() {
        this.isError = false;
        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
        this.on('pointerover', this.onPointerOver);
        this.on('pointerout', this.onPointerOut);
    }

    setDone() {
        this.isDone = true;
        this.scene.replaceItem(this.x, this.y, this.itemData)
        this.destroy()
    }

    setWrong(cardImg) {
        this.isError = true;
        let decalageX = 0
        if (this.trueId === 1) {
            decalageX = 60;
            if (cardImg === 'prodBlack') {
                decalageX = 120
            }
        }

        this.scene.itemsAll.forEach(x => {
            x.setDepth(0)
            if (x.trueId === this.trueId) {
                x.setDepth(2)
            }

        })

        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.item.setTexture(cardImg);
        this.item.x += decalageX;
        this.itemStroke = this.scene.add.graphics();
        this.itemStroke.lineStyle(5, Colors.Elmt.Red, 1); // Définit l'épaisseur et la couleur de la bordure
        this.itemStroke.strokeRect(
            // -this.item.displayWidth / 2,
            -this.item.displayWidth / 2 + decalageX,
            -this.item.displayHeight / 2,
            this.item.displayWidth,
            this.item.displayHeight
        );
        this.add(this.itemStroke);
        // this.itemStroke.setScale(0.9)
        this.itemStroke.setAlpha(0);
        this.scene.tweens.add({
            targets: this.itemStroke,
            alpha: 1,
            duration: 250,
            // ease: 'Linear',
            repeat: 2,
            yoyo: true,
            onComplete: () => {
                // this.item.x -= decalageX;
                // this.item.setScale(0.5);
            }
        });
        this.disableInteractive();
    }

    onPointerOver() {
        if (this.isDone) {
            this.setDepth(2);
            this.item.setScale(1);
        } else {
        }
    }
    onPointerOut() {
        if (this.isDone) {
            this.setDepth(0);
            this.item.setScale(0.5);
        } else {
        }
    }
    dragOnPointerOver() {
        this.item.setTint(0x777777);
    }
    dragOnPointerOut() {
        this.item.setTint(0xFFFFFF);
    }

    setActiveDone() {
        this.newItem = new ItemZoneDone(this.scene, this.x, this.y, this.itemData);
    }

}